import React from "react";
import "../styles/Offers.css";

function Offers() {
  return (
    <section className="offers-section">
      <div className="offers-container">
        <h2 className="offers-heading">🌍 Exclusive Offers</h2>
        <p className="offers-intro">
          At <strong>Global Tongue</strong>, we combine certified expertise, smart
          technology, and cultural insight to deliver language solutions that
          matter. Here’s a brief look at what makes us stand out:
        </p>

        <ul className="offers-list">
          <li>
            ✅ Certified & Accurate Translations
          </li>
          <li>
            🌐 Global Language Coverage
          </li>
          <li>
            ⚡ Fast & Reliable Turnaround
          </li>
          <li>
            🔒 Confidential & Secure Process
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Offers;
